import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, CardMedia, Typography } from "@mui/material";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
  GDD: [ "#F15C22","#000000", "#FFFFFF"],
  MSS: ["#F4D12F", "#C80F2D", "#FFFFFF"],
  PEJ: ["#807E82", "#C1D72E", "#FFFFFF"],
  SRR: ["#008B98", "#B49A64", "#FFFFFF"],
  SCO: ["#C80F2D", "#000000ff", "#FFFFFF"],
  SUR: ["#49A942", "#BA0E2A", "#FFFFFF"],
  "0": ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

const AFL_TEAM_KEY: { [id: string]: string } = {GDD: "Glendale Desert Dogs", MSS: "Mesa Solar Sox", PEJ: "Peoria Javelinas", SRR: "Salt River Rafters", SCO: "Scottsdale Scorpions", SUR: "Surprise Saguaros"}

export default function InfoCard({ playerDataProp, playerInfoProp, idProp }: {playerDataProp: any, playerInfoProp: any, idProp: string | undefined }) {
  //console.log("PIP", playerInfoProp);
  const getHeadshotUrl = () => {
    return `https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:67:current.png/w_213,q_auto:best/v1/people/${idProp}/headshot/67/current`;
  };

  const getMiLBHeadshotUrl = () => {
    return `https://img.mlbstatic.com/mlb-photos/image/upload/c_fill,g_auto/w_180/v1/people/${idProp}/headshot/milb/current`;
  };

  return (
    <div>
      {playerInfoProp.common !== undefined && (
        <div>
          <div
            style={{
              padding: "20px",
              backgroundColor:
                playerDataProp.afl_team !== undefined 
                  ? teamColors[playerDataProp.afl_team][0]
                  : teamColors["FA"][0],
            }}
          >
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={2} // Added spacing between grid items
            >


              {/* Player Info Column */}
              <Grid >
                <Typography variant="h4">
                  <span
                    style={{
                      color:
                        playerDataProp.afl_team !== undefined ? teamColors[
                          playerDataProp.afl_team
                          ][1]
                          : teamColors["FA"][1],
                    }}
                  >
                    {playerInfoProp.common.playerInfo.firstLastName} ⋅{" "}
                    {playerDataProp.Position}
                  </span>
                </Typography>
                <Typography variant="h6">
                  <span
                    style={{
                      color:
                        playerDataProp.afl_team !== undefined 
                          ? teamColors[
                          playerDataProp.afl_team
                          ][2]
                          : teamColors["FA"][2],
                    }}
                  >
                    {playerInfoProp.common.teamInfo !== undefined
                      ? (AFL_TEAM_KEY[playerDataProp.afl_team] +" | "+playerDataProp.MLB_FullName)
                      : "Free Agent"}{" "}
                    (
                    {playerInfoProp.common.teamInfo !== undefined
                      ? playerInfoProp.common.teamInfo.llevel
                      : ""}
                    )
                  </span>
                </Typography>
                <Typography variant="subtitle1">
                  <span
                    style={{
                      color:
                       playerDataProp.afl_team !== undefined ? teamColors[
                          playerDataProp.afl_team
                          ][2]
                          : teamColors["FA"][2],
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>Age:</span>{" "}
                    {playerInfoProp.common.playerInfo.AgeDisplay} ⋅{" "}
                    <span style={{ fontWeight: "bold" }}>DOB:</span>{" "}
                    {playerInfoProp.common.playerInfo.BirthDateDisplay}
                  </span>
                </Typography>
                <Typography variant="subtitle1">
                  <span
                    style={{
                      color:
                        playerDataProp.afl_team !== undefined ? teamColors[
                          playerDataProp.afl_team
                          ][2]
                          : teamColors["FA"][2],
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>Bats/Throws:</span>{" "}
                    {playerInfoProp.common.playerInfo.Bats}/
                    {playerInfoProp.common.playerInfo.Throws} ⋅{" "}
                    <span style={{ fontWeight: "bold" }}>Service Time:</span>{" "}
                    {playerInfoProp.contract.serviceTime
                      ? playerInfoProp.contract.serviceTime
                      : "0.000"}
                  </span>
                </Typography>
                <Typography variant="subtitle1">
                  <span
                    style={{
                      color:
                        playerDataProp.afl_team !== undefined 
                          ? teamColors[
                          playerDataProp.afl_team
                          ][2]
                          : teamColors["FA"][2],
                    }}
                  >
                    <span style={{ fontWeight: "bold" }}>Height:</span>{" "}
                    {playerInfoProp.common.playerInfo.HeightDisplay
                      ? playerInfoProp.common.playerInfo.HeightDisplay
                      : "0.000"} ⋅{" "}
                    <span style={{ fontWeight: "bold" }}>Weight:</span>{" "}
                    {playerInfoProp.common.playerInfo.Weight
                      ? playerInfoProp.common.playerInfo.Weight
                      : "0.000"}
                  </span>
                </Typography>
              </Grid>
            </Grid>
          </div>
          <div style={{ padding: "20px" }}>
            {playerInfoProp.common.prospect[0] !== undefined && (
              <div>
                <Typography variant="h6">
                  Ranks From Report: <a href="https://www.fangraphs.com/prospects/the-board">{playerInfoProp.common.prospect[0].Type}</a>
                  <br />
                  <span style={{ fontWeight: "bold" }}>Overall Rank: </span>
                  {playerInfoProp.common.prospect[0].Ovr_Rank
                    ? playerInfoProp.common.prospect[0].Ovr_Rank
                    : "NR"}
                  {"  ⋅  "}
                  <span style={{ fontWeight: "bold" }}>Org Rank: </span>
                  {playerInfoProp.common.prospect[0].Org_Rank
                    ? playerInfoProp.common.prospect[0].Org_Rank
                    : "NR"}
                </Typography>
              </div>
            )}
            {playerInfoProp.draft !== null && (
              <div>
                <Typography variant="subtitle1">
                  <span style={{ fontWeight: "bold" }}>Draft: </span>
                  {playerInfoProp.draft.season} {playerInfoProp.draft.draftType}
                  , Pick {playerInfoProp.draft.pickNumber} (Round{" "}
                  {playerInfoProp.draft.pickRound}, Pick{" "}
                  {playerInfoProp.draft.roundPickNumber})
                  <br />
                  <span style={{ fontWeight: "bold" }}>Draft Team: </span>
                  {playerInfoProp.draft.TeamName}
                  <br />
                  <span style={{ fontWeight: "bold" }}>Signing Bonus: </span>
                  {playerInfoProp.draft.signingBonusFormat}
                  <br />
                  <span style={{ fontWeight: "bold" }}>School: </span>
                  {playerInfoProp.draft.schoolName}
                  <br />
                </Typography>
              </div>
            )}
            {playerInfoProp.draft === null && (
              <div>
                <Typography variant="subtitle1">
                  <span style={{ fontWeight: "bold" }}>Draft: UDFA</span>
                  {playerInfoProp.common.prospect[0] !== undefined && (
                    <div>
                      <span style={{ fontWeight: "bold" }}>Signing Org: </span>
                      {playerInfoProp.common.prospect[0].Signed_Org} (
                      {playerInfoProp.common.prospect[0].Signed_Yr})
                      <br />
                      <span style={{ fontWeight: "bold" }}>
                        Signing Bonus:{" "}
                      </span>
                      ${playerInfoProp.common.prospect[0].Sign_Bonus}
                      <br />
                      <span style={{ fontWeight: "bold" }}>School: </span>
                      {playerInfoProp.common.prospect[0].School}
                      <br />
                    </div>
                  )}
                </Typography>
              </div>
            )}
          </div>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              gap: 0, // spacing between images
            }}
          >
            <CardMedia
              component="img"
              image={getHeadshotUrl()}
              alt={playerInfoProp.common.playerInfo.firstLastName}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/default-headshot.jpg';
              }}
              sx={{
                width: "40%",
                margin: "auto",
                borderRadius: '25%',
                objectFit: 'cover',
                border: `3px solid ${playerDataProp.afl_team !== undefined ? teamColors[playerDataProp.afl_team][1]
                    : teamColors["FA"][1]
                  }`
              }}
            />
            <CardMedia
              component="img"
              image={getMiLBHeadshotUrl()}
              alt={playerInfoProp.common.playerInfo.firstLastName}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.src = '/default-headshot.jpg';
              }}
              sx={{
                width: "40%",
                margin: "auto",
                borderRadius: '25%',
                objectFit: 'cover',
                border: `3px solid ${playerDataProp.afl_team !== undefined
                    ? teamColors[playerDataProp.afl_team][1]
                    : teamColors["FA"][1]
                  }`
              }}
            />
          </Box>
          <Typography variant="subtitle1" style={{ textAlign: "center", }}><a href="https://www.mlb.com/photos/home" style={{ color: "black" }}>@ MLB Photos</a></Typography>
        </div>
      )}
    </div>
  );
}
